// GAP-Analyse Service Functions
// AUTOMATISCHE GAP-DETECTION - Keine manuellen GAPs!
import api from './api';
import { API_ENDPOINTS } from '../config/constants';

// Helper: Mandant-ID aus Context/Storage holen
const getMandantId = () => {
    const selectedTenant = localStorage.getItem('selectedTenant');
    if (selectedTenant) {
        const tenant = JSON.parse(selectedTenant);
        return tenant.mandant_id;
    }
    return null;
};

// Helper: Mandant-ID Header hinzufügen
const getHeaders = () => {
    const mandantId = getMandantId();
    if (!mandantId) {
        throw new Error('Kein Mandant ausgewählt');
    }
    return {
        'X-Mandant-Id': mandantId,
    };
};

// GET all GAPs (READ-ONLY - automatisch erkannt)
export const getGapAnalysen = async () => {
    try {
        const response = await api.get(API_ENDPOINTS.SCHUTZBEDARFSANALYSE.GAP_ANALYSEN, {
            headers: getHeaders(),
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Fehler beim Laden der GAP-Analysen:', error);
        return { success: false, error: error.response?.data?.detail || error.message };
    }
};

// UPDATE GAP (NUR Maßnahmen editierbar!)
export const updateGapAnalyse = async (gapId, gapData) => {
    try {
        const response = await api.put(
            API_ENDPOINTS.SCHUTZBEDARFSANALYSE.GAP_ANALYSE_BY_ID.replace(':id', gapId),
            gapData,
            {
                headers: getHeaders(),
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Fehler beim Aktualisieren der GAP-Analyse:', error);
        return { success: false, error: error.response?.data?.detail || error.message };
    }
};

// GET GAP Statistics (für Dashboard)
export const getGapStats = async () => {
    try {
        const response = await api.get(API_ENDPOINTS.SCHUTZBEDARFSANALYSE.GAP_STATS, {
            headers: getHeaders(),
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Fehler beim Laden der GAP-Statistiken:', error);
        return { success: false, error: error.response?.data?.detail || error.message };
    }
};

export default {
    getGapAnalysen,
    updateGapAnalyse,
    getGapStats,
};